import React, {FC, useEffect, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography} from '@mui/material';

interface DialogPosition {
    left: number;
    top: number;
}

interface RulerConfirmWidthDialogProps {
    isOpen: boolean;
    defaultWidthMeters: number;
    dialogPosition?: DialogPosition;
    onAdjust: () => void;
    onConfirm: (widthMeters: number) => void;
}

const mmPerMeter = 1000;
const toMillimeters = (meters: number) => Math.round(meters * mmPerMeter);
const toMeters = (millimeters: number) => millimeters / mmPerMeter;

const RulerConfirmWidthDialog: FC<RulerConfirmWidthDialogProps> = (props) => {
    const [widthMillimeters, setWidthMillimeters] = useState(toMillimeters(props.defaultWidthMeters));

    useEffect(() => {
        if (props.isOpen) {
            setWidthMillimeters(toMillimeters(props.defaultWidthMeters));
        }
    }, [props.isOpen, props.defaultWidthMeters]);

    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onAdjust}
            PaperProps={{
                sx: props.dialogPosition
                    ? {
                        position: 'fixed',
                        left: `${props.dialogPosition.left}px`,
                        top: `${props.dialogPosition.top}px`,
                        transform: 'translate(-50%, -50%)',
                        m: 0
                    }
                    : undefined
            }}
        >
            <DialogTitle>Confirm rail width</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{mb: 2}}>
                    Confirm the rail width used for calibration.
                </Typography>
                <TextField
                    data-id="ruler-width-input"
                    type="number"
                    label="Width (mm)"
                    value={widthMillimeters}
                    onChange={(e) => setWidthMillimeters(+e.target.value)}
                    sx={{
                        '& input[type=number]': {
                            MozAppearance: 'textfield'
                        },
                        '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                            WebkitAppearance: 'none',
                            margin: 0
                        }
                    }}
                    fullWidth
                />
                <Stack direction="row" spacing={1} sx={{mt: 2}}>
                    <Button onClick={() => setWidthMillimeters(1435)} variant="outlined">1435</Button>
                    <Button onClick={() => setWidthMillimeters(1600)} variant="outlined">1600</Button>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    data-id="ruler-confirm"
                    onClick={() => props.onConfirm(toMeters(widthMillimeters))}
                    variant="contained">
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RulerConfirmWidthDialog;
